import ErrorSVG from "@design-system/ui-icons/vanilla/Error"
import { createIcon } from "../createIcon"

export const ErrorIcon = createIcon(ErrorSVG)
